import { apiUrl, apiPrefix } from '@/request/config';
import Http from '@/request/Http';

export function login(username, password, captcha, uuid, captchable, companycode) {
  return Http.post('/token', {
    username,
    password,
    captcha,
    uuid,
    captchable,
    companycode,
  });
}

export function loginByAuthcode(authCode) {
  return Http.get(`/integrations?authCode=${authCode}`);
}

export function logout() {
  return Http.delete('/token');
}

export function getProfile() {
  return Http.get(`/profile`);
}

export function updateProfile(profile) {
  return Http.put(`/profile/${profile.userid}`, profile);
}

export function setAvatar() {
  return Http.post('/profile/avatar');
}

export function getAvatarUploadAddress() {
  // return `${apiUrl}/profile/avatar`;
  // TODO: 这个地方地址后期规范以下，不带api/v1
  return `${apiPrefix}/profile/avatar`;
}

export function resetPassword(userid, oldpwd, newpwd) {
  return Http.patch(`/profile/${userid}/userpwd`, {
    oldpwd,
    newpwd,
    encrypted: true,
  });
  // return Http.patch(`/profile/${userid}/userpwd?oldpwd=${oldpwd}&newpwd=${newpwd}`);
}

export function getUserMessages() {
  return Http.get('/profile/messages');
}

export function getSocketService(filename) {
  const agent = navigator.userAgent.toLowerCase();
  let bit = '';
  if (agent.indexOf('win32') >= 0) {
    bit = 32;
  } else bit = 64;
  return Http.download(`${apiUrl}/commprogram`, { bit }, filename);
}

export function getCaptchaImage(uuid) {
  // TODO: 这个地方地址后期规范以下，不带api/v1
  return `${apiPrefix}/captcha?uuid=${uuid}`;
}

export function passwordVerify(password) {
  return Http.post('/profile/password/verify', {
    password,
  });
}
